import React from 'react'
import PropTypes from 'prop-types'
import cx from 'classnames'
import Icon from 'components/Icon'
import styles from './BusinessName.scss'

const BusinessName = ({ alignedLeft = false, business = {} }) => (
  <span className={cx(styles.container, { [styles.alignedLeft]: alignedLeft })}>
    <span className={styles.icons}>
      {business.nonFiler && <Icon name='nonFiler' size='small' />}
      {business.underReport && <Icon name='arrowDown' size='small' />}
    </span>
    <span
      className={cx(styles.name, {
        [styles.withIcons]: business.nonFiler || business.underReport,
      })}
    >
      {business.businessName}
    </span>
  </span>
)

BusinessName.propTypes = {
  alignedLeft: PropTypes.bool,
  business: PropTypes.object,
}

export default BusinessName
